import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardSubTitle,
	CardTitle,
} from '../../../../components/bootstrap/Card';
import USERS from '../../../../common/data/userDummyData';
import useDarkMode from '../../../../hooks/useDarkMode';
import { TColor } from '../../../../type/color-type';
import Chart, { IChartOptions } from '../../../../components/extras/Chart';
import Avatar from '../../../../components/Avatar';
import { getChart } from '../../../../helpers/helper_db';
import Button from '../../../../components/bootstrap/Button';


interface IAnswerCustomerProps {
	id: string | number;
	imgWebp: string;
	img: string;
	name: string;
	job: string;
	value: number;
	rank: number;
	color: TColor | 'link' | 'brand' | 'brand-two' | 'storybook';
	arrow: string;
	rcolor: TColor | 'secondary' | 'success' | 'info';
	errorimg: string;
}
const AnswerCustomer: FC<IAnswerCustomerProps> = (props: IAnswerCustomerProps) => {

	const { id, imgWebp, img, name, job, value, rank, color, arrow, rcolor, errorimg } = props;
	const { darkModeStatus } = useDarkMode();
	
	const [state] = useState<IChartOptions>({
		series: [value],
		options: {
			chart: {
				type: 'radialBar',
				width: 50,
				height: 50,
				sparkline: {
					enabled: true,
				},
			},
			dataLabels: {
				enabled: false,
			},
			plotOptions: {
				radialBar: {
					hollow: {
						margin: 0,
						size: '50%',
					},
					track: {
						margin: 0,
					},
					dataLabels: {
						show: false,
					},
				},
			},
			stroke: {
				lineCap: 'round',
			},
			colors: [
				(color === 'primary' && process.env.REACT_APP_PRIMARY_COLOR) ||
				(color === 'secondary' && process.env.REACT_APP_SECONDARY_COLOR) ||
				(color === 'success' && process.env.REACT_APP_SUCCESS_COLOR) ||
				(color === 'info' && process.env.REACT_APP_INFO_COLOR) ||
				(color === 'warning' && process.env.REACT_APP_WARNING_COLOR) ||
				(color === 'danger' && process.env.REACT_APP_DANGER_COLOR),
			],
		},
	});
	return (
		<div className='col-12'>
			<div className='row g-2'>
				<div className='col d-flex'>
					<div className='flex-shrink-0'>
						<span className='me-4 h5'>{rank}</span>
						<Avatar
							src={img}
							srcSet={imgWebp}
							size={35}
							userName={name}
							color={color}
							errorSrc={errorimg}
						/>
					</div>
					<div className='flex-grow-1 ms-3 d-flex justify-content-between align-items-center'>
						<div>
							<Link
								to={`../1`}
								className={classNames('fw-bold fs-6 mb-0', {
									'link-dark': !darkModeStatus,
									'link-light': darkModeStatus,
								})}>
								{name}
							</Link>
							<div className='text-muted mt-n1'>
								<small>{job}</small>
							</div>
						</div>
					</div>
				</div>
				<div className='col-auto'>
					<div className='d-flex align-items-center'>
						<Button

							color={rcolor} //down secondary up success equals info
							icon={arrow} // equals ArrowForward UP ArrowUpward DOWN ArrowDownward
							//onClick={handleUpcomingDetails}
							aria-label=''
						/>

					</div>
				</div>
			</div>
		</div>
	);
};

interface ICommonProps {
	country?: String;
	format?: number;
	countryname?: String;
	format_name?: String;
	flag?: String;
	hcolor?: String;
	css?: string;
	arrow?: string;
	rcolor?: string;
	url?: string;
}

const CommonDashboardWaitingAnswer: FC<ICommonProps> = ({ country, format, countryname, format_name, flag, hcolor, css, arrow, rcolor, url }) => {
	const { darkModeStatus } = useDarkMode();
	const [charts, setCharts] = useState([]);
	useEffect(() => {
		getChart(country, format).then(p => {
			setCharts(p);
			console.log(p);
		});
	}, []);

	return (
		<Card stretch className='shadow-none'>
			<CardHeader className={css} >
				<CardLabel >
					<CardTitle tag='div' >
						Top {format_name} <img src={flag?.toString()} width="25" height="25">
						</img>
					</CardTitle>

				</CardLabel>

			</CardHeader>
			<CardBody>
				<div className='row g-3'>
					{charts.map(({ cs_song, title, artists, rank, img, arrow, rcolor, errorimg }) =>
						<AnswerCustomer
							id={cs_song}
							name={title}
							job={artists}
							img={img}
							imgWebp={img}
							color={USERS.JANE.color}
							rank={rank}
							value={35}
							arrow={arrow}
							rcolor={rcolor}
							errorimg={errorimg}
						/>)}


				</div>
			</CardBody>

				<CardTitle tag='div' className='card-center' >
					<Link
						target="_blank"
						to={`${url}`}
						className={classNames('fw-bold fs-6 mb-0', {
							'link-dark': !darkModeStatus,
							'link-light': darkModeStatus,
						})}>
						{'Ver más'}
						
					</Link>
				</CardTitle>




		</Card>
	);
};

export default CommonDashboardWaitingAnswer;
